import type { TableStickyColumns } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { selectVisibleColumns } from 'components/Table/model/selectors/selectVisibleColumns';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectStickyColumnsSettings: (
  s: TableMergedState,
) => TableStickyColumns = createScopedSelector(() =>
  createSelector(
    selectVisibleColumns,
    prop('settings', 'stickyColumns'),
    prop('disableStickyColumn'),
    (visibleColumns, stickyColumns, disableStickyColumn) => {
      if (stickyColumns) {
        return stickyColumns;
      }
      if (disableStickyColumn) {
        return {};
      }
      // When no stickiness settings were applied yet, mark first non-sticky column sticky by default.
      const firstNonSticky = visibleColumns.find((c) => !c.sticky);
      if (firstNonSticky) {
        return {
          [firstNonSticky.key]: true,
        };
      }
      return {};
    },
  ),
);
